import { render, staticRenderFns } from "./HelpCenterFields.vue?vue&type=template&id=324690ba&scoped=true"
import script from "./HelpCenterFields.vue?vue&type=script&lang=js"
export * from "./HelpCenterFields.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterFields.vue?vue&type=style&index=0&id=324690ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324690ba",
  null
  
)

export default component.exports